<template>
  <section>
    <div class="col-sm-12 col-md-12 form-group pt-3 mt-4">
      <h4 class="text-white fontPersonalizada mb-5">Sua senha foi salva com sucesso!</h4>

      <!-- <p
        class="col fontMenor mb-5"
        style="word-break: break-word;"
      >
        Faça o login com sua nova senha
      </p> -->

      <!-- <div class="col-sm-12 col-md-12 form-group mt-4 mb-4 pt-2">
        <button
          class="btn btn-block shadow-sm btnStock btn"
          :style="primaryBtnStyle"
          @click="$router.push('/login')"
        >
          LOGIN
        </button>
      </div> -->
    </div>
  </section>
</template>

<script>
/* State */
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Completo',
  computed: {
    ...mapGetters(['primaryBtnStyle']),
    ...mapState(['template', 'config', 'subdomain']),
  },
}
</script>
